;
define("product_views_option_radio.tpl", function(){});

